import React from "react";

function ViewEnquiry({ data }) {
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      new: "bg-primary",
      contacted: "bg-success",
      approved: "bg-success",
      closed: "bg-secondary",
      pending: "bg-warning",
    };
    return statusMap[status?.toLowerCase()] || "bg-secondary";
  };

  return (
    <div className="card-body">
      <div className="row">

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Enquiry From</strong>
          <p>{data?.type || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Name</strong>
          <p>{data?.name || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Email</strong>
          <p style={{ wordBreak: "break-word" }}>{data?.email || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Mobile</strong>
          <p>{data?.mobile || data?.phone || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Subject</strong>
          <p>{data?.subject || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Status</strong>
          <p>
            <span className={`badge ${getStatusBadge(data?.status)}`}>
              {data?.status
                ? data.status.charAt(0).toUpperCase() + data.status.slice(1)
                : "-"}
            </span>
          </p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <strong>Admin Remark</strong>
          <p>{data?.admin_remark || "-"}</p>
        </div>

        <div className="col-12 col-sm-6 col-md-6 mb-3">
          <label className="form-label">Date</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={data?.created_at ? formatDateTime(data.created_at) : "-"}
            readOnly
          />
        </div>

        <div className="col-12 mb-3">
          <strong>Message</strong>
          <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {data?.message || "-"}
          </p>
        </div>

      </div>
    </div>
  );
}

export default ViewEnquiry;